import { forwardRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Box } from '../../../../base-components';
import { IBoxAndLazyImageProps, ImageRatio } from './interfaces';
import { StyledBox, StyledRatioBox } from './PreviewImage.styles';

interface Props extends IBoxAndLazyImageProps {
    ratio?: ImageRatio;
    disabledEffect?: boolean;
}

const PreviewImage = forwardRef<HTMLSpanElement, Props>((props: Props, ref) => {
    const {
        ratio,
        disabledEffect = false,
        effect = 'blur',
        sx,
        ...other
    } = props;
    const content = (
        <Box
            component={LazyLoadImage}
            wrapperClassName="wrapper"
            effect={disabledEffect ? undefined : effect}
            placeholderSrc={
                disabledEffect
                    ? '/assets/transparent.png'
                    : '/assets/placeholder.svg'
            }
            sx={{ width: 1, height: 1, objectFit: 'cover' }}
            {...other}
        />
    );

    if (ratio) {
        return (
            <StyledRatioBox ref={ref} component="span" ratio={ratio} sx={sx}>
                {content}
            </StyledRatioBox>
        );
    }

    return (
        <StyledBox ref={ref} component="span" sx={sx}>
            {content}
        </StyledBox>
    );
});

export default PreviewImage;
